import React from 'react';
interface SectionHeadingProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string;
}

/** The site's standard yellow section heading with the red rule beneath. */
export function SectionHeading({
  title,
  subtitle,
  className = 'mb-12'
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-319" data-mp="3jznfifmga7la">
      <h2 className="text-3xl sm:text-5xl md:text-6xl font-black uppercase mb-4" data-id="element-320" data-mp="3k29jk5a4u4yr">
        <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" style={{
        backgroundImage: "linear-gradient(180deg, #FFE81A 0%, rgb(234, 179, 8) 100%)"
      }} data-id="element-321" data-mp="bkvimtn7aqxk">
          {title}
        </span>
      </h2>
      <div className="h-1 w-24 bg-red-600 mx-auto rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)]" data-id="element-322" data-mp="6tdk0c8nh2fr" />
      {subtitle && <p className="text-gray-400 text-lg max-w-2xl mx-auto mt-4" data-id="element-323" data-mp="uizewnhzovhy">{subtitle}</p>}
    </div>;
}